module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-1.jpg?v=f0e33f9d";